// extracted by mini-css-extract-plugin
export default {"headerText":"HeaderCell_headerText__hmZM0","sortBtnDiv":"HeaderCell_sortBtnDiv__C8VS+","sortBtn":"HeaderCell_sortBtn__BLOzH","rotate180":"HeaderCell_rotate180__HRHS6"};